import { useTranslation } from 'react-i18next';
import s from './styles';
import Day from './Day';

function Schedule({ editing = true }) {
  const { t } = useTranslation();
  const weekDays = [
    t('containers.SettingsStoreHours.monday'),
    t('containers.SettingsStoreHours.tuesday'),
    t('containers.SettingsStoreHours.wednesday'),
    t('containers.SettingsStoreHours.thursday'),
    t('containers.SettingsStoreHours.friday'),
    t('containers.SettingsStoreHours.saturday'),
    t('containers.SettingsStoreHours.sunday'),
  ];
  return (
    <s.BodyContainer editing={editing}>
      {weekDays.map((day, index) => (
        <Day
          length={weekDays.length}
          key={index}
          index={index}
          day={day}
          editing={editing}
        />
      ))}
    </s.BodyContainer>
  );
}

export default Schedule;
